import React from 'react';

import connect from '../messageStore/connect';
import MessagesContainer from './MessagesContainer';

class Messages extends React.Component {
  componentDidMount() {
    this.props.getMoreMessages();
  }

  render() {
    return (
      <MessagesContainer
        getMoreMessages={this.props.getMoreMessages}
        deleteMessage={this.props.deleteMessage}
        messages={this.props.messages}
        loading={this.props.loading}
      />
    );
  }
};

export default connect(Messages);



// WEBPACK FOOTER //
// ./src/Messages/index.js